import { styled } from '@mui/material';

export const ValueViewer = styled('div')({
  cursor: 'pointer',
  width: '100%',
  height: '100%',
});

export const ValueContainer = styled('div')({
  position: 'relative',
  height: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'end',
});

export const dateFieldSx = (hasError: boolean) => ({
  width: '100%',
  '& .MuiInputBase-input': {
    fontFamily: '"Open Sans", sans-serif, arial !important',
    padding: '6px 0',
    textAlign: 'right !important',
    ...(hasError && {
      color: 'red',
      borderColor: 'red',
    }),
  },
});
